/* ==========================================================================
   byob-pdm : Build Your Own Bundle (self-contained logic)

   - Reads all config from the section's [data-byob-config] JSON (no magic
     numbers): min/max items, discount %, labels, money format, subscribe.
   - Manages bundle state client-side (add / remove / qty, min-max rules).
   - Adds each selected product/variant as its OWN cart line item, tagged with
     bundle line-item properties so a future Cart Transform extension can merge
     them into one bundle line and apply the discount:
         properties[_bundle_pdm_id]      shared group id for this bundle
         properties[_bundle_discount] configured discount percent
         properties[_bundle_min_max]  "<min>:<max>"
   - Optional Recharge "Subscribe & Save" modal: adds each line with the
     matching selling_plan id for the chosen frequency.
   - Refreshes the theme cart drawer via its existing reloadCartDrawer() API.
   ========================================================================== */
;(function () {
  "use strict"

  var root = document.querySelector("[data-byob-pdm]")
  if (!root) return

  /* ----------------------------- config -------------------------------- */
  var cfg = {
    minItems: 2,
    maxItems: 6,
    discountPercent: 15,
    enableSubscribe: true,
    labels: {},
  }
  try {
    var cfgEl = root.querySelector("[data-byob-config]")
    if (cfgEl) cfg = Object.assign(cfg, JSON.parse(cfgEl.textContent))
  } catch (e) {
    console.warn("[byob-pdm] could not parse config", e)
  }
  var L = cfg.labels || {}
  var DISCOUNT = Number(cfg.discountPercent) || 0
  var MIN = Number(cfg.minItems) || 0
  var MAX = Number(cfg.maxItems) || 999
  var MIN_AMOUNT_CENTS = Math.round((Number(cfg.minAmount) || 0) * 100)
  var MONEY_FORMAT = cfg.moneyFormat || "${{amount}}"

  /* --------------------------- money helper ---------------------------- */
  function formatMoney(cents) {
    if (typeof cents === "string") cents = cents.replace(".", "")
    var value = ""
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
    var formatString = MONEY_FORMAT

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = isNaN(precision) ? 2 : precision
      thousands = thousands || ","
      decimal = decimal || "."
      if (isNaN(number) || number == null) return 0
      number = (number / 100).toFixed(precision)
      var parts = number.split(".")
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands)
      var centsAmount = parts[1] ? decimal + parts[1] : ""
      return dollarsAmount + centsAmount
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2)
        break
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0)
        break
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",")
        break
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",")
        break
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ",")
        break
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ", "")
        break
      default:
        value = formatWithDelimiters(cents, 2)
    }
    return formatString.replace(placeholderRegex, value)
  }

  function discounted(cents) {
    return Math.round(cents * (1 - DISCOUNT / 100))
  }

  /* ----------------------------- state --------------------------------- */
  // key = variantId -> { productId, variantId, title, variantTitle, image, price, plans, quantity }
  var state = new Map()

  function totalQty() {
    var n = 0
    state.forEach(function (i) {
      n += i.quantity
    })
    return n
  }
  function subtotal() {
    var n = 0
    state.forEach(function (i) {
      n += i.price * i.quantity
    })
    return n
  }

  /* --------------------------- card parsing ---------------------------- */
  var cards = Array.prototype.slice.call(root.querySelectorAll("[data-byob-card]"))

  function parseJSONAttr(el, name, fallback) {
    var raw = el.getAttribute(name)
    if (!raw) return fallback
    try {
      return JSON.parse(raw)
    } catch (e) {
      return fallback
    }
  }

  function cardCurrent(card) {
    var select = card.querySelector("[data-byob-variant-select]")
    var variants = parseJSONAttr(card, "data-variants", [])
    var variantId, price, title
    if (select) {
      variantId = Number(select.value)
      var opt = select.options[select.selectedIndex]
      price = Number(opt && opt.getAttribute("data-price"))
      title = opt ? opt.textContent.trim() : ""
    } else {
      variantId = Number(card.getAttribute("data-variant-id"))
      price = Number(card.getAttribute("data-price"))
      title = ""
    }
    if (!price || isNaN(price)) {
      var match = variants.filter(function (v) {
        return v.id === variantId
      })[0]
      price = match ? match.price : Number(card.getAttribute("data-price"))
    }
    return {
      productId: Number(card.getAttribute("data-product-id")),
      variantId: variantId,
      title: card.getAttribute("data-title") || "",
      variantTitle: title,
      image: card.getAttribute("data-image") || "",
      price: price,
      plans: parseJSONAttr(card, "data-plans", []),
    }
  }

  /* --------------------------- DOM refs -------------------------------- */
  var itemsEl = root.querySelector("[data-byob-items]")
  var guidanceEl = root.querySelector("[data-byob-guidance]")
  var guidanceWrapEl = root.querySelector("[data-byob-guidance-wrap]")
  var savingsEl = root.querySelector("[data-byob-savings]")
  var counterEl = root.querySelector("[data-byob-counter]")
  var addBtn = root.querySelector("[data-byob-add]")
  var footEl = root.querySelector("[data-byob-foot]")
  var summaryInnerEl = root.querySelector("[data-byob-summary-inner]")
  var addTotalEl = root.querySelector("[data-byob-add-total]")
  var toastEl = root.querySelector("[data-byob-toast]")
  var toastTimer = null

  function icon(name) {
    var tpl = root.querySelector("[data-byob-icon-" + name + "]")
    if (tpl && tpl.content) return tpl.content.cloneNode(true)
    return document.createTextNode("")
  }

  function escapeHtml(s) {
    return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
  }

  // Guidance with the "save NN%" portion emphasised, like the reference design.
  function setGuidance(text) {
    var html = escapeHtml(text).replace(/(save\s+\d+%)/i, "<strong>$1</strong>")
    guidanceEl.innerHTML = html
  }

  // Savings line with a bold amount.
  function setSavings(savingsCents) {
    var parts = (L.savings || "you're saving {amount}!").split("{amount}")
    savingsEl.textContent = ""
    savingsEl.appendChild(document.createTextNode(parts[0] || ""))
    var strong = document.createElement("strong")
    strong.textContent = formatMoney(savingsCents)
    savingsEl.appendChild(strong)
    if (parts[1]) savingsEl.appendChild(document.createTextNode(parts[1]))
  }

  function toast(msg) {
    if (!toastEl) return
    toastEl.textContent = msg
    toastEl.hidden = false
    clearTimeout(toastTimer)
    toastTimer = setTimeout(function () {
      toastEl.hidden = true
    }, 2400)
  }

  /* ----------------------------- actions ------------------------------- */
  function addVariant(data) {
    if (totalQty() >= MAX) {
      toast(L.maxReached || "You've reached the max.")
      return false
    }
    var existing = state.get(data.variantId)
    if (existing) {
      existing.quantity += 1
    } else {
      data.quantity = 1
      state.set(data.variantId, data)
    }
    render()
    return true
  }

  function setQty(variantId, qty) {
    var item = state.get(variantId)
    if (!item) return
    if (qty <= 0) {
      state.delete(variantId)
    } else {
      if (qty > item.quantity && totalQty() >= MAX) {
        toast(L.maxReached || "You've reached the max.")
        return
      }
      item.quantity = qty
    }
    render()
  }

  /* ------------------------------ render ------------------------------- */
  function render() {
    var qty = totalQty()
    var sub = subtotal()
    var savings = Math.round(sub * (DISCOUNT / 100))

    var amountMet = sub >= MIN_AMOUNT_CENTS
    var valid = qty >= MIN && qty <= MAX && amountMet

    // items list (per-item discount only shown once the bundle is complete)
    itemsEl.innerHTML = ""
    state.forEach(function (item) {
      itemsEl.appendChild(renderItem(item, valid))
    })

    // counter
    if (counterEl) counterEl.textContent = qty + " / " + MAX

    // empty vs active summary layout
    var isEmpty = qty === 0
    if (summaryInnerEl) {
      summaryInnerEl.classList.toggle("byob-pdm__summary-inner--empty", isEmpty)
    }

    // The foot (add-to-cart button + savings) only appears once the bundle is
    // valid. Until then we show the guidance notice below the divider instead.
    if (footEl) footEl.hidden = !valid
    if (guidanceWrapEl) guidanceWrapEl.hidden = valid

    // guidance / savings
    if (!valid) {
      if (qty >= MIN && !amountMet) {
        var remaining = Math.max(0, MIN_AMOUNT_CENTS - sub)
        guidanceEl.textContent = (
          L.minAmount || "add {amount} more to complete your bundle."
        ).replace("{amount}", formatMoney(remaining))
      } else {
        setGuidance(L.guidance || "")
      }
      guidanceEl.hidden = false
      savingsEl.hidden = true
    } else {
      guidanceEl.hidden = true
      if (DISCOUNT > 0 && savings > 0) {
        setSavings(savings)
        savingsEl.hidden = false
      } else {
        savingsEl.hidden = true
      }
    }

    // add to cart button
    addBtn.disabled = !valid
    var addSepEl = root.querySelector("[data-byob-add-sep]")
    if (qty > 0) {
      var shown = valid && DISCOUNT > 0 ? discounted(sub) : sub
      addTotalEl.textContent = formatMoney(shown)
      if (addSepEl) addSepEl.hidden = false
    } else {
      addTotalEl.textContent = ""
      if (addSepEl) addSepEl.hidden = true
    }

    // reflect in-bundle state on cards
    cards.forEach(function (card) {
      var ids = parseJSONAttr(card, "data-variants", []).map(function (v) {
        return v.id
      })
      var inBundle = false
      state.forEach(function (i) {
        if (ids.indexOf(i.variantId) !== -1) inBundle = true
      })
      card.classList.toggle("is-in-bundle", inBundle)
    })
  }

  function renderItem(item, valid) {
    var li = document.createElement("li")
    li.className = "byob-pdm-item"

    var img = document.createElement("img")
    img.className = "byob-pdm-item__img"
    img.src = item.image
    img.alt = item.title
    img.loading = "lazy"
    li.appendChild(img)

    var info = document.createElement("div")
    info.className = "byob-pdm-item__info"

    var title = document.createElement("p")
    title.className = "byob-pdm-item__title"
    title.textContent = item.title
    info.appendChild(title)

    if (item.variantTitle && item.variantTitle !== "Default Title") {
      var vt = document.createElement("p")
      vt.className = "byob-pdm-item__variant"
      vt.textContent = item.variantTitle
      info.appendChild(vt)
    }

    var prices = document.createElement("div")
    prices.className = "byob-pdm-item__prices"
    if (valid && DISCOUNT > 0) {
      var was = document.createElement("span")
      was.className = "byob-pdm-item__price-was"
      was.textContent = formatMoney(item.price)
      prices.appendChild(was)
      var now = document.createElement("span")
      now.className = "byob-pdm-item__price-now"
      now.textContent = formatMoney(discounted(item.price))
      prices.appendChild(now)
    } else {
      var only = document.createElement("span")
      only.className = "byob-pdm-item__price-now"
      only.textContent = formatMoney(item.price)
      prices.appendChild(only)
    }
    info.appendChild(prices)
    li.appendChild(info)

    var controls = document.createElement("div")
    controls.className = "byob-pdm-item__controls"

    var remove = document.createElement("button")
    remove.type = "button"
    remove.className = "byob-pdm-item__remove"
    remove.setAttribute("aria-label", L.remove || "remove")
    remove.appendChild(icon("trash"))
    remove.addEventListener("click", function () {
      setQty(item.variantId, 0)
    })
    controls.appendChild(remove)

    var qtyWrap = document.createElement("div")
    qtyWrap.className = "byob-pdm-qty"

    var minus = document.createElement("button")
    minus.type = "button"
    minus.className = "byob-pdm-qty__btn"
    minus.setAttribute("aria-label", "Decrease quantity")
    minus.appendChild(icon("minus"))
    minus.addEventListener("click", function () {
      setQty(item.variantId, item.quantity - 1)
    })

    var val = document.createElement("span")
    val.className = "byob-pdm-qty__val"
    val.textContent = item.quantity

    var plus = document.createElement("button")
    plus.type = "button"
    plus.className = "byob-pdm-qty__btn"
    plus.setAttribute("aria-label", "Increase quantity")
    plus.appendChild(icon("plus"))
    plus.disabled = totalQty() >= MAX
    plus.addEventListener("click", function () {
      setQty(item.variantId, item.quantity + 1)
    })

    qtyWrap.appendChild(minus)
    qtyWrap.appendChild(val)
    qtyWrap.appendChild(plus)
    controls.appendChild(qtyWrap)

    li.appendChild(controls)
    return li
  }

  /* ------------------------- card interactions ------------------------- */
  cards.forEach(function (card) {
    var addCardBtn = card.querySelector("[data-byob-card-add]")
    var select = card.querySelector("[data-byob-variant-select]")
    var priceEl = card.querySelector("[data-byob-card-price]")

    if (select && priceEl) {
      select.addEventListener("change", function () {
        var opt = select.options[select.selectedIndex]
        var p = Number(opt && opt.getAttribute("data-price"))
        if (!isNaN(p)) priceEl.textContent = formatMoney(p)
      })
    }

    if (addCardBtn) {
      addCardBtn.addEventListener("click", function () {
        addVariant(cardCurrent(card))
      })
    }
  })

  /* ----------------------------- cart add ------------------------------ */
  function buildBundleId() {
    return (
      (cfg.bundleIdPrefix || "byob-pdm") +
      "-" +
      Date.now() +
      "-" +
      Math.random().toString(36).slice(2, 8)
    )
  }

  function buildItems(frequencyLabel) {
    var bundleId = buildBundleId()
    var items = []
    state.forEach(function (item) {
      var line = {
        id: item.variantId,
        quantity: item.quantity,
        properties: {
          _bundle_pdm_id: bundleId,
          _bundle_discount: String(DISCOUNT),
          _bundle_min_max: MIN + ":" + MAX,
          _bundle_min_amount: String(MIN_AMOUNT_CENTS),
        },
      }
      if (frequencyLabel) {
        var planId = findPlanId(item, frequencyLabel)
        if (planId) line.selling_plan = planId
      }
      items.push(line)
    })
    return items
  }

  function getSectionsToRender() {
    var drawer =
      document.querySelector("cart-drawer") ||
      document.querySelector("cart-notification")
    if (drawer && typeof drawer.getSectionsToRender === "function") {
      return drawer.getSectionsToRender().map(function (s) {
        return s.id
      })
    }
    return ["cart-drawer", "cart-icon-bubble"]
  }

  function submit(items) {
    if (!items.length) return
    addBtn.classList.add("is-loading")

    var body = {
      items: items,
      sections: getSectionsToRender(),
      sections_url: window.location.pathname,
    }

    var cartAddUrl = (window.routes && window.routes.cart_add_url) || "/cart/add"

    fetch(cartAddUrl + ".js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify(body),
    })
      .then(function (r) {
        return r.json()
      })
      .then(function (response) {
        if (response && response.status && response.description) {
          toast(response.description)
          return
        }
        // reset bundle
        state.clear()
        render()
        closeModal()

        var drawer = document.querySelector("cart-drawer")
        if (
          drawer &&
          typeof drawer.reloadCartDrawer === "function" &&
          response.sections
        ) {
          // If the cart was empty on page load, <cart-drawer> still carries the
          // `is-empty` class, and `.is-empty .cart__contents` (component-cart.css)
          // hides the freshly rendered line items until a full reload. Clear it so
          // the added bundle shows immediately.
          drawer.classList.remove("is-empty")
          drawer.setActiveElement && drawer.setActiveElement(document.activeElement)
          drawer.reloadCartDrawer(response)
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || "/cart"
        }
      })
      .catch(function (e) {
        console.error("[byob-pdm] add to cart failed", e)
        toast("Something went wrong, please try again.")
      })
      .finally(function () {
        addBtn.classList.remove("is-loading")
      })
  }

  /* -------------------------- subscribe modal -------------------------- */
  var modal = root.querySelector("[data-byob-modal]")
  var freqSelect = root.querySelector("[data-byob-frequency]")
  var freqWrap = root.querySelector("[data-byob-frequency-wrap]")
  var subscribeBtn = root.querySelector("[data-byob-subscribe]")
  var modalAddBtn = root.querySelector("[data-byob-modal-add]")
  var subscribeTotalEl = root.querySelector("[data-byob-subscribe-total]")
  var onetimeTotalEl = root.querySelector("[data-byob-onetime-total]")

  function planLabel(plan) {
    // Prefer the plan's human-readable title (e.g. "Deliver every 30 days").
    if (plan.name) return String(plan.name)
    if (plan.options && plan.options.length) {
      var o = plan.options[0]
      if (o && typeof o === "object" && o.value != null) return String(o.value)
      if (o != null) return String(o)
    }
    return plan.id != null ? String(plan.id) : ""
  }

  // returns array of {id, label} plans for an item (flattened across groups)
  function itemPlans(item) {
    var out = []
    ;(item.plans || []).forEach(function (group) {
      ;(group.selling_plans || []).forEach(function (plan) {
        out.push({ id: plan.id, label: planLabel(plan) })
      })
    })
    return out
  }

  function findPlanId(item, label) {
    var plans = itemPlans(item)
    for (var i = 0; i < plans.length; i++) {
      if (plans[i].label === label) return plans[i].id
    }
    return null
  }

  function anyPlansAvailable() {
    var found = false
    state.forEach(function (item) {
      if (itemPlans(item).length) found = true
    })
    return found
  }

  function buildFrequencyOptions() {
    if (!freqSelect) return false
    var labels = []
    state.forEach(function (item) {
      itemPlans(item).forEach(function (p) {
        if (p.label && labels.indexOf(p.label) === -1) labels.push(p.label)
      })
    })
    freqSelect.innerHTML = ""
    labels.forEach(function (label) {
      var opt = document.createElement("option")
      opt.value = label
      opt.textContent = label
      freqSelect.appendChild(opt)
    })
    // Default to the last available plan.
    if (labels.length) freqSelect.selectedIndex = labels.length - 1
    if (freqWrap) freqWrap.hidden = labels.length === 0
    return labels.length > 0
  }

  function openModal() {
    if (!modal) return
    buildFrequencyOptions()
    var sub = subtotal()
    var shown = DISCOUNT > 0 ? discounted(sub) : sub
    if (subscribeTotalEl) subscribeTotalEl.textContent = formatMoney(shown)
    if (onetimeTotalEl) onetimeTotalEl.textContent = formatMoney(shown)
    modal.hidden = false
    document.body.classList.add("byob-pdm-modal-open")
  }

  function closeModal() {
    if (!modal) return
    modal.hidden = true
    document.body.classList.remove("byob-pdm-modal-open")
  }

  // Celebrate the add with the theme's global canvas-confetti (loaded in layout).
  function triggerConfetti() {
    if (typeof window.confetti !== "function") return
    window.confetti({
      particleCount: 100,
      startVelocity: 30,
      spread: 360,
      shapes: ["star"],
      zIndex: 1000001,
      origin: { x: 0.5, y: 0.5 },
    })
  }

  if (modal) {
    root.querySelectorAll("[data-byob-modal-close]").forEach(function (el) {
      el.addEventListener("click", closeModal)
    })
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !modal.hidden) closeModal()
    })
  }
  if (subscribeBtn) {
    subscribeBtn.addEventListener("click", function () {
      triggerConfetti()
      var label = freqSelect && freqSelect.value ? freqSelect.value : null
      submit(buildItems(label))
    })
  }
  if (modalAddBtn) {
    modalAddBtn.addEventListener("click", function () {
      triggerConfetti()
      submit(buildItems(null))
    })
  }

  /* ------------------------- main add handler -------------------------- */
  addBtn.addEventListener("click", function () {
    var qty = totalQty()
    if (qty < MIN || qty > MAX || subtotal() < MIN_AMOUNT_CENTS) return
    if (cfg.enableSubscribe && anyPlansAvailable()) {
      openModal()
    } else {
      submit(buildItems(null))
    }
  })

  /* ------------------------------ init --------------------------------- */
  render()
})()
